/* eslint-disable unicorn/no-unused-properties */

import { css, keyframes } from 'styled-components';

// Base Motion Values
const EASE = {
  OUT_EXPO: 'cubic-bezier(0.19, 1, 0.22, 1)',
};

const DURATIONS = {
  FAST: '200ms',
  NORMAL: '400ms',
  SLOW: '600ms',
};

// CSS Keyframes
const FADE_IN_KEYFRAMES = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const FADE_OUT_KEYFRAMES = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const SLIDE_UP_KEYFRAMES = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;

// CSS Animation Strings
export const FADE_IN_ANIMATION = css`
  ${FADE_IN_KEYFRAMES} ${DURATIONS.SLOW} ${EASE.OUT_EXPO};
`;

export const FADE_OUT_ANIMATION = css`
  ${FADE_OUT_KEYFRAMES} ${DURATIONS.SLOW} ${EASE.OUT_EXPO};
`;

export const SLIDE_UP_ANIMATION = css`
  ${SLIDE_UP_KEYFRAMES} ${DURATIONS.SLOW} ${EASE.OUT_EXPO};
`;

// Framer Motion Props
export const FADE_IN_BOUNCE_PROPS = {
  animate: { opacity: 1, y: 0 },
  initial: { opacity: 0, y: 25 },
  transition: {
    opacity: { duration: 0.3, ease: [0.23, 1, 0.32, 1] },
    y: { stiffness: 150, type: 'spring' },
  },
};

export const COLLAPSE_OUT_PROPS = {
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
  initial: { height: 'auto', opacity: 1 },
  transition: {
    duration: 0.3,
  },
};
